import { MbeFlag } from '@/components/icons/MbeFlag';
import type { ILanguage } from '@/types';

export const languages: ILanguage[] = [
  {
    id: 'it',
    label: 'it',
    icon: MbeFlag,
    countryCode: 'it',
  },
  {
    id: 'en',
    label: 'en',
    icon: MbeFlag,
    countryCode: 'uk',
  },
  {
    id: 'fr',
    label: 'fr',
    icon: MbeFlag,
    countryCode: 'fr',
  },
  {
    id: 'es',
    label: 'es',
    icon: MbeFlag,
    countryCode: 'es',
  },
  {
    id: 'de',
    label: 'de',
    icon: MbeFlag,
    countryCode: 'de',
  },
];

export const apiUrl = process.env.REACT_APP_API_URL;
